package com.essntl.uikit.components.checkbox

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsPrimaryCheckBox(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    EsCheckBox(
        checked = checked,
        onCheckedChange = onCheckedChange,
        colors = EsCheckBoxColors(
            backgroundCheckedBoxColor = MaterialTheme.esColorScheme.primary,
            backgroundUncheckedBoxColor = MaterialTheme.esColorScheme.secondaryHover,
            borderCheckedBoxColor = Color.Transparent,
            checkMarkColor = Color.White,
            disabledCheckedBoxColor = MaterialTheme.esColorScheme.secondaryDisabled,
            disabledCheckMarkColor = MaterialTheme.esColorScheme.iconDisabled,
        ),
        enabled = enabled,
        modifier = modifier,
    )
}

@Composable
fun EsTriPrimaryCheckBox(
    state: EsCheckBoxState,
    onClick: () -> Unit,
    enabled: Boolean = true,
    colors: EsCheckBoxColors? = null,
    modifier: Modifier = Modifier,
) {
    EsTriCheckBox(
        state = state,
        onClick = onClick,
        colors = colors ?: EsCheckBoxColors(
            backgroundCheckedBoxColor = MaterialTheme.esColorScheme.primary,
            backgroundUncheckedBoxColor = MaterialTheme.esColorScheme.secondaryHover,
            borderCheckedBoxColor = Color.Transparent,
            checkMarkColor = Color.White,
            disabledCheckedBoxColor = MaterialTheme.esColorScheme.secondaryDisabled,
            disabledCheckMarkColor = MaterialTheme.esColorScheme.iconDisabled,
        ),
        enabled = enabled,
        modifier = modifier,
    )
}